import { useGetTeamsWithinOrganizationQuery } from '../../../hooks';
import { Spinner } from '../../../components/Spinner';
import { TeamsList } from '../../../components/TeamsList/TeamsList';
import { Heading } from '../../../components/Heading';
import { Alert } from '../../../components/Alert/Alert';
import { LinkButton } from '../../../components/LinkButton';
import { Routes } from '../../../enums/Routes';
import classes from './TeamsOverviewPage.module.css';
import { OrgOverviewTopBar } from '../../../components/OrgOverviewTopBar';
import { EmptyState } from '../../../components/EmptyState';
import { PersonGroupIcon } from '@navikt/aksel-icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const TeamsOverviewPage = () => {
  const { t } = useTranslation();
  const { data: teams, error } = useGetTeamsWithinOrganizationQuery();
  const navigate = useNavigate();

  const handleCreateTeam = () => {
    navigate(Routes.OrganizationCreateTeam);
  };

  if (teams) {
    // Empty state when no teams exist
    if (teams.length === 0) {
      return (
        <>
          <OrgOverviewTopBar />
          <div className={classes.container}>
            <EmptyState
              icon={<PersonGroupIcon aria-hidden fontSize="48px" />}
              title={t('teams.overview.emptyState.title')}
              description={t('teams.overview.emptyState.description')}
              actionLabel={t('teams.overview.emptyState.action')}
              onAction={handleCreateTeam}
            />
          </div>
        </>
      );
    }

    return (
      <>
        <OrgOverviewTopBar />
        <div className={classes.container}>
          <div>
            <div className={classes.header}>
              <Heading as="h1">{t('teams.overview.pageTitle')}</Heading>
              <LinkButton to={Routes.OrganizationCreateTeam}>
                {t('teams.overview.createButton')}
              </LinkButton>
            </div>
            <TeamsList items={teams} isTeamEditable={false} />
          </div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <Alert title={error.message} variant="danger" size="lg">
        {t('teams.overview.error.message')}
      </Alert>
    );
  }

  return (
    <>
      <Spinner label={t('teams.overview.loading')} />
      <p>{t('teams.overview.loadingShort')}</p>
    </>
  );
};
